module.exports = __webpack_public_path__ + "img/img31.374c8c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img31.jpg
// module id = 298
// module chunks = 0